import PhuyenBusiness from './PhuyenBusiness.jsx';

export {PhuyenBusiness}
export default PhuyenBusiness;



// WEBPACK FOOTER //
// ./components/business/phuyen-business/index.js